/* Footer country choose */
window.addEventListener('load', function() {
    $(".footer-change-country").click(function(){
        $(".select-country").css("display","block");
    });
    $(".country-modal, .style-module__modal-close").click(function(){
        $(".select-country").css("display","none");
    });
});
/* Footer country choose */
